import * as actionTypes from './actionTypes';
import api from './api';
import { sendHttpRequest } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';
import schemas from 'utils/schemas';
import { normalize } from 'normalizr';
import { camelizeKeys } from 'humps';

export const loadFacilitiesKey = (filters, pageSize) => {
  return JSON.stringify({ ...filters, pageSize });
};

export function loadPagedFacilities(filters, page, pageSize) {
  return async (dispatch, getState) => {
    const key = loadFacilitiesKey(filters, pageSize);
    const facilities = getState().facilities.list[key];
    let shouldCallApi = !(facilities && facilities[page]);
    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_FACILITIES_STARTED, key, page, pageSize });

    try {
      const response = await dispatch(sendHttpRequest(api.getPagedFacilities(filters, page, pageSize)));
      const camelizedJson = camelizeKeys(response.values);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.facilities));

      dispatch({
        entitiesCategory: 'facilities',
        type: actionTypes.LOAD_FACILITIES_SUCCEEDED,
        key,
        page,
        totalCount: response.totalCount,
        totalPages: response.totalPages,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FACILITIES_FAILED, key, page, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
